import { docReady } from "./utils";
import navbarInit from "./navbar-darken-on-scroll";
import detectorInit from "./detector";
import zanimationInit from "./zanimation";

docReady(navbarInit);
docReady(detectorInit);
docReady(zanimationInit);

docReady(() => {
  const udaraText = `
██  ██ █████  █████  █████  █████
██  ██ ██  ██ ██  ██ ██  ██ ██  ██
██  ██ ██  ██ ██████ █████  ██████
██  ██ ██  ██ ██  ██ ██  ██ ██  ██
██████ █████  ██  ██ ██  ██ ██  ██
`;

  const supunText = `
██████ ██  ██ ██████ ██  ██ ██  ██
██     ██  ██ ██  ██ ██  ██ ███ ██
██████ ██  ██ ██████ ██  ██ ██████
    ██ ██  ██ ██     ██  ██ ██ ███
██████ ██████ ██     ██████ ██  ██
`;

  const styleUdara = `
    color: #ccff00;
    font-family: monospace;
    font-weight: bold;
    line-height: 1.2;
    text-shadow: 2px 2px 0px #222, 4px 4px 0px #ccff00;
  `;

  const styleSupun = `
    color: #ffffff;
    font-family: monospace;
    font-weight: bold;
    line-height: 1.2;
    text-shadow: 2px 2px 0px #222, 4px 4px 0px #ffffff;
  `;

  console.log("%c" + udaraText + "%c" + supunText, styleUdara, styleSupun);
});
